import { BadgeCheck } from "lucide-react";
import AdminList from "@/admin/components/AdminList";

export default function RouteList() {
  return (
    <AdminList
      testId="admin-routes-list"
      title="Rotas"
      kicker="Gestão de Conteúdo"
      resource="routes"
      createTo="/admin/rotas/nova"
      editTo="/admin/rotas"
      columns={[
        {
          key: "name", label: "Nome",
          render: (r) => (
            <div className="flex items-center gap-3">
              {r.cover_image && <img src={r.cover_image} alt="" className="w-12 h-12 rounded-lg object-cover border border-[#2a2a2a]" />}
              <div>
                <div className="text-white font-medium">{r.name}</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-[#7d7d7d] mt-0.5">{r.slug}</div>
              </div>
            </div>
          ),
        },
        { key: "state", label: "Estado" },
        { key: "distance_km", label: "Km", render: (r) => `${r.distance_km || 0} km` },
        { key: "difficulty", label: "Dificuldade" },
        {
          key: "verified", label: "Verificada",
          render: (r) => r.verified
            ? <span className="text-[#C6A762] inline-flex items-center gap-1 text-xs"><BadgeCheck size={13} /> Sim</span>
            : <span className="text-[#7d7d7d] text-xs">Não</span>,
        },
      ]}
    />
  );
}
